import styled, { css } from "styled-components";
import { CoreTypography } from "@boi/components-core";
import { parseSizeToken, useDesignTokens } from "@boi/react-design-tokens";

import { Typography } from "../Typography";

export const TextInputWrapper = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { textInput } = tokens;

    return css`
      width: 100%;
      height: ${textInput.height};
      display: flex;
      align-items: center;
      padding-right: ${textInput.paddingRight};
      padding-left: ${textInput.paddingLeft};
    `;
  }}
`;

export const CustomTextInput = styled.input`
  ${() => {
    const { tokens } = useDesignTokens();
    const { textInput, typography } = tokens;

    const typographyVariant: CoreTypography.Variant =
      textInput.typography.variant;

    const fontSize = parseSizeToken(typography.fontSize[typographyVariant]);
    const lineHeight = parseSizeToken(typography.lineHeight[typographyVariant]);

    return css`
      width: 100%;
      background: none;
      padding: 0;
      border: none;
      outline: none;

      color: ${textInput.color.base};
      font-family: ${typography.fontFamily[typographyVariant]};
      font-size: ${fontSize};
      line-height: ${lineHeight};

      &:read-only {
        color: ${textInput.color.readOnly};
      }

      &:disabled {
        color: ${textInput.color.disabled};
      }
    `;
  }}
`;

export const Prefix = styled(Typography)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { textInput } = tokens;

    return css`
      color: ${textInput.prefix.color};
      margin-right: ${textInput.prefix.marginRight};
    `;
  }}
`;

export const IconWrapper = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { textInput } = tokens;

    return css`
      display: flex;
      align-items: center;
      margin-left: ${textInput.icon.marginLeft};
    `;
  }}
`;
